var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"flex-initial justify-between items-baseline py-3 px-4 h-12",domProps:{"innerHTML":_vm._s(this.leadSuccessMessage)}})}
var staticRenderFns = []

export { render, staticRenderFns }